import { render } from "./DocumentationView.vue?vue&type=template&id=f170c10c"
import script from "./DocumentationView.vue?vue&type=script&lang=js"
export * from "./DocumentationView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__